import type { UserAvatarAssetGroupInfo } from '../api/userAvatarAssetGroup';

export type VirtualAvatarGroupOptionKey = 'custom' | 'default';

export interface VirtualAvatarGroupOption {
  key: VirtualAvatarGroupOptionKey;
  label: string;
  groupId: string;
}

/** 是否存在与默认组不同的用户配置组（is_custom 且 asset_group_id 有效） */
export const hasVirtualAvatarCustomGroup = (info: UserAvatarAssetGroupInfo): boolean => {
  return false;
};

/** 有配置组时：配置组在前、默认组在后；仅默认组时只返回默认组一项 */
export const buildVirtualAvatarGroupOptions = (
  info: UserAvatarAssetGroupInfo,
): VirtualAvatarGroupOption[] => {
  const options: VirtualAvatarGroupOption[] = [];
  if (info.groupId) {
    options.push({ key: 'default', label: '默认组', groupId: info.groupId });
  }
  return options;
};

/** 有配置组时优先选中配置组，否则选第一项（默认组） */
export const pickInitialVirtualAvatarGroupId = (
  options: VirtualAvatarGroupOption[],
): string => {
  if (!options.length) return '';
  const custom = options.find((o) => o.key === 'custom');
  if (custom) return custom.groupId;
  return options[0].groupId;
};

/** 刷新时：当前组仍有效则保留，否则按 pickInitial 规则回退 */
export const resolveVirtualAvatarGroupSelection = (
  options: VirtualAvatarGroupOption[],
  currentGroupId: string,
): string => {
  if (!options.length) return '';
  const cur = currentGroupId.trim();
  if (cur && options.some((o) => o.groupId === cur)) return cur;
  return pickInitialVirtualAvatarGroupId(options);
};
